(function() {
    'use strict';

    angular.module('ecap.common', []);

})();

